import Vue from 'vue';
import Router from 'vue-router';
import Results from './pages/Results.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history', //APP NOT RENDERING WHEN ENABLED
  routes: [
    {
      path: '/',
      name: 'results',
      component: Results,
      props: route => ({
        theme: route.query.theme || 'default',
      }),
    },
  ],
});
